// Changes input value to current Partner Club Name for Cart Tracking.
const partnerName = getPartnerInfo().clubName;
const clubNameInput = document.querySelector(`input#partner-club-input`);

if (clubNameInput) {
    clubNameInput.value = partnerName;
}


// Creates link to this product's SoundGear.com page.
const productPath = window.location.pathname;
const productDescriptionElement = document.querySelector(`.product__description`);

const supportParagraphElement = document.createElement("p");
supportParagraphElement.innerHTML = `For more details and product support please visit this product on <a href="http://soundgear.com${productPath}" target="_blank">SoundGear.com</a>.<small class="discount-disclaimer">Your discount code will <em>not</em> work on SoundGear.com. It will only work on this&nbsp;site.</p>`;

productDescriptionElement.appendChild(supportParagraphElement);